export default __webpack_public_path__ + "static/media/shopping-bag-2.8da88426.png";